import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import * as React from 'react';

import { Badge } from '@mui/material';
import classNames from 'classnames';
import styles from '../styles/components/menu-accordion.module.scss';


interface MenuAccordionProps {
  label: string
  id: string
  children: React.ReactNode
  counter?: number | null
  onChange?: (expanded: boolean) => void
  disabled?: boolean
  labelButtons?: React.ReactNode | null

}
export const MenuAccordion = ({
  label,
  id,
  children,
  counter,
  onChange,
  disabled = false,
  labelButtons = null
}: MenuAccordionProps) => {
  const [isExpanded, setExpanded] = React.useState(false)
  return (
    <div className={styles.wrapper}>
      <Accordion
        disabled={disabled}
        key={`${id}`}
        className={styles.accordion}
        onChange={(event: React.SyntheticEvent, expanded: boolean) => {
          if (onChange) {
            onChange(expanded)
          }
          setExpanded(expanded)
        }}
      >
        <AccordionSummary
          className={styles.summary}
          expandIcon={<ExpandMoreIcon sx={{color: '#010824'}} />}
        >
          {typeof counter === "number" ?
            <Badge
              className={classNames(styles.badge, {
                [styles.isExpanded]: isExpanded && counter > 0
              })}
              showZero
              badgeContent={counter}
              color="success"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
            {label}
            </Badge>
            :
            <>{label}</>
          }
        </AccordionSummary>
        <AccordionDetails
          className={styles.details}
        >
          {children}
        </AccordionDetails>
      </Accordion>
      {labelButtons && <div className={styles.labelButtons}>{labelButtons}</div>}
    </div>
  )
}